// Define multiple themes
export const themes = {
  // Original synthwave theme
  synthwave: {
    name: 'Synthwave',
    colors: {
      background: '#1a1a2e',
      background2: '#16213e',
      background3: '#0f0f1e',
      foreground: '#ffe66d',
      accentGreen: '#06ffa5',
      accentCyan: '#4ecdc4',
      accentOrange: '#ff6b35',
      accentPurple: '#7209b7',
      border: '#4ecdc4',
      shadow: 'rgba(78, 205, 196, 0.3)',
    },
  },
  // Classic green terminal theme
  terminal: {
    name: 'Classic Terminal',
    colors: {
      background: '#0c0c0c',
      background2: '#1a1a1a',
      background3: '#000000',
      foreground: '#00ff00',
      accentGreen: '#33ff33',
      accentCyan: '#00ffff',
      accentOrange: '#ffaa00',
      accentPurple: '#ff00ff',
      border: '#00ff00',
      shadow: 'rgba(0, 255, 0, 0.3)',
    },
  },
  // Matrix-inspired green-on-black
  matrix: {
    name: 'Matrix',
    colors: {
      background: '#000000',
      background2: '#0d1117',
      background3: '#050505',
      foreground: '#00d900',
      accentGreen: '#00ff41',
      accentCyan: '#008f11',
      accentOrange: '#00b300',
      accentPurple: '#00ff00',
      border: '#00ff41',
      shadow: 'rgba(0, 255, 65, 0.4)',
    },
  },
  // A deep midnight theme with dark blues and purples
  midnight: {
    name: 'Midnight',
    colors: {
      background: '#0f1021',
      background2: '#1a1b2d',
      background3: '#05050f',
      foreground: '#b3b7ff',
      accentGreen: '#4fd1c5',
      accentCyan: '#2cb5e0',
      accentOrange: '#d7875f',
      accentPurple: '#9070ff',
      border: '#2cb5e0',
      shadow: 'rgba(44, 181, 224, 0.3)',
    },
  },
  // A neon sunset theme with warm accents on a black base
  neonSunset: {
    name: 'Neon Sunset',
    colors: {
      background: '#0a0a0a',
      background2: '#1f0a17',
      background3: '#120611',
      foreground: '#ffd1e3',
      accentGreen: '#ff6f61',
      accentCyan: '#ff9a8d',
      accentOrange: '#ffb85c',
      accentPurple: '#ff99cc',
      border: '#ff6f61',
      shadow: 'rgba(255, 111, 97, 0.3)',
    },
  },
  // A deep sea theme inspired by ocean blues and teals
  deepSea: {
    name: 'Deep Sea',
    colors: {
      background: '#001f2d',
      background2: '#002d40',
      background3: '#00141f',
      foreground: '#a6dcef',
      accentGreen: '#5fb0b7',
      accentCyan: '#00a1c7',
      accentOrange: '#ffa55c',
      accentPurple: '#5b6ca8',
      border: '#00a1c7',
      shadow: 'rgba(0, 161, 199, 0.3)',
    },
  },
};

// Default exported theme
export const theme = themes.synthwave;
